import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames/bind';
import TrackFavorite from '~/components/legacy/TrackFavorite.jsx';
import SoundEffectFavorite from '~/components/legacy/SoundEffectFavorite.jsx';
import { parseReactProps } from '~/components/legacy/reactProps.js';
import legacyEventHub, { cartItemsFromEvent } from '~/modules/legacyRuntime.js';

class TrackFavorites extends Component {

  constructor(props) {
    super(props);

    this.handleClick = this.handleClick.bind(this);
    this.closeFavorites = this.closeFavorites.bind(this);
    this.handleCartClick = this.handleCartClick.bind(this);
    this.createPortalRoot = this.createPortalRoot.bind(this);
    this.destroyPortalRoot = this.destroyPortalRoot.bind(this);
    this.handleUpdateTrackFavorites = this.handleUpdateTrackFavorites.bind(this);
    this.handleUpdateSoundEffectFavorites = this.handleUpdateSoundEffectFavorites.bind(this);
    this.handleUpdateCart = this.handleUpdateCart.bind(this);
    this.handleMenuCartOpened = this.handleMenuCartOpened.bind(this);
    this.handleClosePopupMenus = this.handleClosePopupMenus.bind(this);
    this.registerEventHubListener = this.registerEventHubListener.bind(this);
    this.unregisterEventHubListeners = this.unregisterEventHubListeners.bind(this);
    this.renderDrawerMarkup = this.renderDrawerMarkup.bind(this);

    this.eventHubListeners = [];

    this.state = {
      opened: false,
      recentlyUpdated : false,
      data : this.props.data,
      trackFavoritesData : this.props.track_favorites_data,
      soundEffectFavoritesData : this.props.sound_effect_favorites_data,
      cart_items : this.props.cart_items,
      showUsageLicenseSelectForTrackId : []
     };
  }

  componentDidMount() {
      this.createPortalRoot();
      this.registerEventHubListener('updateTrackFavorites', this.handleUpdateTrackFavorites);
      this.registerEventHubListener('updateSoundEffectFavorites', this.handleUpdateSoundEffectFavorites);
      this.registerEventHubListener('updateCart', this.handleUpdateCart);
      this.registerEventHubListener('menuCartOpened', this.handleMenuCartOpened);
      this.registerEventHubListener('closePopupMenus', this.handleClosePopupMenus);

  }

  componentWillUnmount() {
    this.unregisterEventHubListeners();
    this.destroyPortalRoot();
  }

  registerEventHubListener(eventName, handler) {
    legacyEventHub.on(eventName, handler);
    this.eventHubListeners.push({ eventName: eventName, handler: handler });
  }

  unregisterEventHubListeners() {
    if (!legacyEventHub || typeof legacyEventHub.off !== 'function') {
      this.eventHubListeners = [];
      return;
    }

    this.eventHubListeners.forEach((listener) => {
      legacyEventHub.off(listener.eventName, listener.handler);
    });
    this.eventHubListeners = [];
  }

  createPortalRoot() {
    if (typeof document === 'undefined' || this.portalRoot) {
      return;
    }

    this.portalRoot = document.createElement('div');
    this.portalRoot.className = 'track-favorites__portal';
    document.body.appendChild(this.portalRoot);
  }

  destroyPortalRoot() {
    if (!this.portalRoot) {
      return;
    }

    if (this.portalRoot.parentNode) {
      this.portalRoot.parentNode.removeChild(this.portalRoot);
    }

    this.portalRoot = null;
  }

  handleUpdateTrackFavorites(data) {
    this.setState({trackFavoritesData: data[0], recentlyUpdated: true});

    if (data[0].length === 0) {
      this.setState({opened: false});
    }

    setTimeout(() => {
      this.setState({recentlyUpdated: false});
    }, 1000);
  }

  handleUpdateSoundEffectFavorites(data) {
    this.setState({soundEffectFavoritesData: data[0], recentlyUpdated: true});
    if (data[0].length === 0) {
      this.setState({opened: false});
    }
    setTimeout(() => {
      this.setState({recentlyUpdated: false});
    }, 1000);
  }

  handleUpdateCart(data) {
    const cartItems = cartItemsFromEvent(data);

    this.setState({cart_items: cartItems});

    if (cartItems.length === 0) {
      this.setState({opened: false});
    }
  }

  handleMenuCartOpened() {
    this.setState({opened: false});
  }

  handleClosePopupMenus() {
    this.setState({opened: false, showUsageLicenseSelectForTrackId: []});
  }

  handleClick() {
    if (!this.state.opened) {
      legacyEventHub.trigger('menuFavoritesOpened');
    }

    this.setState({opened: !this.state.opened});
  }

  closeFavorites() {
    this.setState({ opened: false });
  }

  handleCartClick(trackId) {
    let stateObject = {},
        indexOfTrackId = this.state.showUsageLicenseSelectForTrackId.indexOf(trackId);

    if (indexOfTrackId === -1) {
        stateObject = {};
        stateObject['showUsageLicenseSelectForTrackId'] = [];
        stateObject['showUsageLicenseSelectForTrackId'].push(trackId);
    } else {
      stateObject = {};
      stateObject['showUsageLicenseSelectForTrackId'] = this.state.showUsageLicenseSelectForTrackId;
      stateObject['showUsageLicenseSelectForTrackId'].splice( stateObject['showUsageLicenseSelectForTrackId'].indexOf(trackId), 1 );
    }

    this.setState(stateObject);
  }

  isUsageLicenseSelectVisible(trackId) {
    if (this.state.showUsageLicenseSelectForTrackId.indexOf(trackId) > -1) {
        return true;
    }

    return false;
  }

  trackIsInCart(trackId, cartItems) {
    let i,
        cartItemsLength = cartItems && cartItems.length ? cartItems.length : 0;

    for (i = 0; i < cartItemsLength; i += 1) {
        if (cartItems[i].track_id === trackId) {
            return true;
        }
    }
    return false;
  }

  soundEffectIsInCart(sound_effect_id, cartItems) {
    let i,
        cartItemsLength = cartItems && cartItems.length ? cartItems.length : 0;

    for (i = 0; i < cartItemsLength; i += 1) {
        if (cartItems[i].sound_effect_id === sound_effect_id) {
            return true;
        }
    }
    return false;
  }

  renderDrawerMarkup(favorites) {
    if (!this.state.opened || favorites.length === 0) {
      return null;
    }

    const closeLabel = this.props.locale === 'de' ? 'Merkliste schließen' : 'Close favorites';
    const emptyLabel = this.props.locale === 'de' ? 'Sie haben noch keine Titel gemerkt.' : 'You have not saved any titles yet.';

    return (
      <div className='track-favorites__drawer-shell'>
        <div className='track-favorites__backdrop' onClick={this.closeFavorites}></div>
        <div className='track-favorites__drawer'>
          <div className='track-favorites__drawer-header'>
            <div className='track-favorites__list-heading'>{this.props.i18n.heading} ({favorites.length})</div>
            <button type='button' className='track-favorites__drawer-close' onClick={this.closeFavorites} aria-label={closeLabel}>
              <i className='fa fa-times'></i>
            </button>
          </div>
          <div className='track-favorites__drawer-body'>
            {favorites.length > 0 ? favorites : <div className='track-favorites__empty-copy'>{emptyLabel}</div>}
          </div>
        </div>
      </div>
    );
  }

  render() {
    let trackFavorites = [],
        soundEffectFavorites = [],
        favorites = [],
        submitButton,
        classes;

    if (this.state.trackFavoritesData) {
        trackFavorites = this.state.trackFavoritesData.map(function (trackFavorite, index) {
          return (
            <TrackFavorite
              locale={this.props.locale}
              i18n={this.props.i18n}
              id={trackFavorite.track_id}
              title={trackFavorite.title}
              free={trackFavorite.free}
              cart_items={this.state.cart_items}
              inCart={this.trackIsInCart(trackFavorite.track_id, this.state.cart_items)}
              discount={trackFavorite.discount}
              composer_name={trackFavorite.composer_name}
              length={trackFavorite.length}
              showcase_url={trackFavorite.showcase_url}
              track_image_markup={trackFavorite.track_image}
              subscribedUsageLicenseTypes={this.props.subscribedUsageLicenseTypes}
              usageLicenseTypes={this.props.usage_license_types.filter(function(usageLicenseType) { return usageLicenseType.for_fx === false })}
              trackFavorites={this.state.trackFavoritesData}
              licenseNavigatorPath={this.props.licenseNavigatorPath}
              handleCartClick={this.handleCartClick}
              showUsageLicenseSelect={this.isUsageLicenseSelectVisible(trackFavorite.track_id)}
              key={"trackFavorite-" + trackFavorite.track_id + '-' + index}
            />
          );
        }.bind(this));
    }

    if (this.state.soundEffectFavoritesData) {
      soundEffectFavorites = this.state.soundEffectFavoritesData.map(function (soundEffectFavorite, index) {
        return (
          <SoundEffectFavorite
            locale={this.props.locale}
            i18n={this.props.i18n}
            id={soundEffectFavorite.sound_effect_id}
            title={soundEffectFavorite.title}
            free={soundEffectFavorite.free}
            cart_items={this.state.cart_items}
            inCart={this.soundEffectIsInCart(soundEffectFavorite.sound_effect_id, this.state.cart_items)}
            discount={soundEffectFavorite.discount}
            subscribedUsageLicenseTypes={this.props.subscribedUsageLicenseTypes}
            usageLicenseTypes={this.props.usage_license_types.filter(function(usageLicenseType) { return usageLicenseType.for_fx === true })}
            handleCartClick={this.handleCartClick}
            showUsageLicenseSelect={this.isUsageLicenseSelectVisible(soundEffectFavorite.sound_effect_id)}
            key={"sound-effect-favorite-" + soundEffectFavorite.sound_effect_id + '-' + index}
          />
        );
      }.bind(this));
    }

    favorites = soundEffectFavorites.concat(trackFavorites)

    classes = classNames({
      'track-favorites': true,
      'is-open' : this.state.opened,
      'is-closed' : !this.state.opened,
      'is-empty' : favorites.length === 0,
      'is-recently-updated' : this.state.recentlyUpdated
    });

    const drawerMarkup = this.renderDrawerMarkup(favorites);

    return (
      <div className={classes}>
        <div className='track-favorites__status clearfix' onClick={favorites.length > 0 ? this.handleClick : function(){}}>
          <div className='track-favorites__circle'>
            <span className='track-favorites__tracks-count'>{favorites.length}</span>
          </div>
          <span className='track-favorites__symbol'>
            <i className={favorites.length > 0 ? 'fa fa-heart' : 'fa fa-heart-o'}></i>
          </span>
        </div>
        {this.portalRoot && drawerMarkup ? ReactDOM.createPortal(drawerMarkup, this.portalRoot) : drawerMarkup}
      </div>
    )
  }
};

TrackFavorites.defaultProps = {
  data : [],
  i18n : {
    heading : 'Gemerkte Tracks'
  },
  usage_license_types : []
}

// INIT

let elements = document.querySelectorAll('[data-react-component=TrackFavorites]');

elements.forEach(function(element) {
  try {
    let reactProps = parseReactProps(element.dataset.reactProps);

    ReactDOM.render(
      <React.StrictMode>
        <TrackFavorites {...reactProps} />
      </React.StrictMode>,
      element
    );
  } catch (error) {
    console.error('Failed to mount TrackFavorites', error);
  }
})

export default TrackFavorites;
